import { useEffect } from "react";
import DashboardPreviewSection from "./DashboardPreviewSection";
import HeroSection from "./HeroSection";
import OurServices from "./OurServices";
import Pricing from "./Pricing";
import ReadyToAutomate from "./ReadyToAutomate";
import Review from "./Review";
import FadeInSection from "../components/FadeInSection";

export default function HomePage() {
    useEffect(() => {
        if (window.location.hash) {
            const id = window.location.hash.replace("#", "");

            setTimeout(() => {
                document.getElementById(id)?.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                });
            }, 100);
        }
    }, []);

    return (
        <>
            <div id="" className="">
                <FadeInSection>
                    <HeroSection
                        className="lg:px-24 md:px-12 px-6 md:py-20 py-16"

                    />
                </FadeInSection>
            </div>
            <div id="features" className="scroll-mt-10">
                <FadeInSection>

                    <OurServices
                        className="lg:px-24 md:px-12 px-6 md:py-20 py-16"
                    />
                </FadeInSection>
            </div>
            <div id="" className="">
                <FadeInSection>
                    <DashboardPreviewSection
                        className="lg:px-24 md:px-12 px-6 md:py-20 py-16"
                    />
                </FadeInSection>
            </div>
            {/* <div id="pricing" className="">
                <Pricing
                    className="lg:px-24 md:px-12 px-6 md:py-20 py-16"
                />
            </div> */}
            <div id="" className="">
                <FadeInSection>
                    <Review
                        className="lg:px-24 md:px-12 px-6 md:py-20 py-16 lg:pb-40 pb-20"
                    />
                </FadeInSection>
            </div>
            <div id="" className="">
                <FadeInSection>
                    <ReadyToAutomate
                        className="lg:px-24 md:px-12 px-6 md:py-20 py-16"
                    />
                </FadeInSection>
            </div>
        </>
    )
}
